import sendRequest from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
import { useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";

const CartItemsContext = createContext({
  items: [],
  setItems: () => {},
  editCartItems: () => {},
  updateCartItemsFunc: () => {},
  length: 0,
});

export default CartItemsContext;

export function CartItemsProvider({ children }) {
  const [items, setItems] = useState([]);
  const [updateCartItems, setUpdateCartItems] = useState(false);
  const [length, setLength] = useState("0");
  const editCartItems = async (type, productId) => {
    let { data } = await sendRequest("cartitem", {
      situation: type,
      productId,
    });
    return +data.status;
  };
  const updateCartItemsFunc = () => {
    setUpdateCartItems((prev) => !prev);
  };
  useEffect(() => {
    sendRequest2("get_cart_items").then(({ data }) => {
      // console.log("data", data);
      setItems(data.cart_items);
      setLength(data.cart_items?.length);
    });
  }, [updateCartItems]);

  // console.log("items", items);

  return (
    <>
      <CartItemsContext.Provider
        value={{
          items,
          setItems,
          editCartItems,
          updateCartItemsFunc,
          length,
        }}
      >
        {children}
      </CartItemsContext.Provider>
    </>
  );
}
